require('./ui-bootstrap-tpls');
module.exports = 'ui.bootstrap';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-ui-bootstrap/index.js
 ** module id = 975
 ** module chunks = 0 1 3 4 5 6
 **/